import { Client, getStateCallbacks } from "@colyseus/sdk";
import { GameState, ROOM_NAME } from "@ghostland/shared";
import { GAME_SERVER_URL } from "../config.js";
import { session } from "../auth/session.js";

/** Connect to the Colyseus game room as a specific character, authenticating with the token. */
export function joinGameRoom(characterId?: string) {
  const client = new Client(GAME_SERVER_URL);
  // The SDK sends this as the Authorization header; the server verifies it in onAuth.
  client.auth.token = session.token ?? "";
  // characterId is validated server-side against the account in onJoin.
  return client.joinOrCreate<GameState>(ROOM_NAME, { characterId }, GameState);
}

export { getStateCallbacks };
